<template>
    <svg class="icon" viewBox="0 0 19 17.7276" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <circle cx="11.6696" cy="7.33105" r="6.83" stroke="currentColor" />
        <circle cx="7.33105" cy="10.3972" r="6.83" stroke="currentColor" />
    </svg>
</template>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .icon {
        @apply block h-[1em] w-[1.07em] shrink-0;
    }
}
</style>
